import { Component, OnInit, ViewChild, Injectable, OnDestroy } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DatatableService } from '../../../shared/services/datatable.service';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { Router, ActivatedRoute } from '@angular/router';
import { EncriptyUtilService } from '../../../shared/services/encripty-util.service';
import { SimulacaoVendaService } from './simulacao-venda.service';
import { ModalSimulacaoVendaComponent } from './modal-simulacao-venda/modal-simulacao-venda.component';
import { NbDialogService } from '@nebular/theme';
import { PinPadService } from '../../../shared/services/adiq/pinpad/pinpad.service';
import { AdministrativeService } from '../../../shared/services/adiq/administrative/administrative.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DateUtilService } from '../../../shared/services/date-util.service';
import { Financial } from '../../../shared/model/Financial';
import { FinancialService } from '../../../shared/services/adiq/financial/financial.service';
import { TransactionInfoBuilder } from '../../../shared/builders/TransactionInfoBuilder';
import { HttpParams } from '@angular/common/http';
import { PinPadComponent } from '../../../shared/components/resources/pinpad.component';
import { NotificationsService } from 'angular2-notifications';
import { TransactionInfo } from '../../../shared/model/TransactionInfo';
import * as moment from "moment";


enum ModalidadeTransacao {
  DEBITO = 4,
  CREDITO_VISTA = 1,
  CREDITO_PARCELADO = 2,
}

enum EtapaProcessamento {
  TRANSACAO_PINPAD_PENDENTE = 'TRANSACAO_PINPAD_PENDENTE',
  SIMULADOR_PENDENTE = 'SIMULADOR_PENDENTE',
  VENDA_TX_PENDENTE = 'VENDA_TX_PENDENTE',
  CONFIRMA_VENDA_TX_PENDENTE = 'CONFIRMA_VENDA_TX_PENDENTE',
  FINALIZADO = 'FINALIZADO',
}


@Component({
  selector: 'ngx-simulacao-venda',
  templateUrl: './simulacao-venda.component.html',
  styleUrls: ['./simulacao-venda.component.scss'],
})
export class SimulacaoVendaComponent extends PinPadComponent implements OnInit, OnDestroy {
  @ViewChild('myTable', null)
  private table: DatatableComponent;

  public formSimulaVenda = null;
  public listTaxa: Array<any> = null;
  public listBandeira: Array<any> = null;
  public listTipo: Array<any> = null;
  public rowData: any;
  public parcelaSelecionada = null;
  public simulaVenda = null;

  selected: boolean = false;

  public valorCobrar = null;
  public valorReceber = null;
  public parcela = null;
  public valorVenda: string = null;
  public tipoTaxa = null;
  public bandeira = null;
  public modalidade = null;
  public financial: Financial;
  public pinpadStatus: boolean = true;
  public liberarSelecaoParcelas: boolean = false;
  public liberarTransacao: boolean = false;
  private transactionInfoBuilder: TransactionInfoBuilder;
  public customLogin = null;

  constructor(
    private formBuilder: FormBuilder,
    private datatableService: DatatableService,
    private router: Router,
    private encriptyService: EncriptyUtilService,
    private service: SimulacaoVendaService,
    public notificationService: NotificationsService,
    private activatedRoute: ActivatedRoute,
    private dialogService: NbDialogService,
    public pinPadService: PinPadService,
    public administrativeService: AdministrativeService,
    public spinnerService: NgxSpinnerService,
    public dateUtilService: DateUtilService,
    private financialService: FinancialService,
  ) {

    super(notificationService, spinnerService, dateUtilService, pinPadService, administrativeService);

    this.enterpriseFederalId = this.encriptyService.decriptyBySecretKey(
      localStorage.getItem('bway-enterprise-federal-id')
    );

    this.activatedRoute.queryParams.subscribe((params) => {
      this.valorVenda = this.encriptyService.decriptyBySecretKey(
        params.valorVenda
      );
      this.tipoTaxa = this.encriptyService.decriptyBySecretKey(params.tipoTaxa);
      this.bandeira = this.encriptyService.decriptyBySecretKey(params.bandeira);
      this.modalidade = this.encriptyService.decriptyBySecretKey(
        params.modalidade
      );
    });

    this.formSimulaVenda = this.formBuilder.group({
      valorVenda: [this.valorVenda],
      tipoTaxa: [this.tipoTaxa],
      bandeira: [this.bandeira],
      modalidade: [this.modalidade],
      valorPago: [null],
      valorReceber: [null],
      tipoTransacao: [null],
    });
    this.financial = new Financial();

  }

  ngOnInit() {
   
    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    this.datatableService.subscribeTable(this.table);
    this.inicializacao();
  }

  async inicializacao() {
    await this.buscaTerminais();
    setTimeout(() => {
      this.pinpadInit();
    }, 3000);

  }

  ngOnDestroy() {
    this.datatableService.unsubscribeTable(this.table);
    this.desativarPinPad();
  }

  setInitValues() {
    this.listTaxa = [
      {
        tipoTaxa: 'USUARIO',
        descricao: 'USUÁRIO',
      },
      {
        tipoTaxa: 'ESTABELECIMENTO',
        descricao: 'ESTABELECIMENTO',
      },
    ];

    this.listTipo = [
      {
        modalidade: 'CREDITO',
        descricao: 'CRÉDITO',
      },
      {
        modalidade: 'DEBITO',
        descricao: 'DEBITO',
      },
    ];

    this.listBandeira = [
      {
        bandeira: 'MASTERCARD',
        descricao: 'MASTERCARD',
      },
      {
        bandeira: 'ELO',
        descricao: 'ELO',
      },
      {
        bandeira: 'VISA',
        descricao: 'VISA',
      },
    ];
  }

  tipoBandeira(data) {

    if (data == 'ELO') {
      this.bandeira = data;
    } else if (data == 'MASTERCARD') {
      this.bandeira = data;
    } else if (data == 'VISA') {
      this.bandeira = data;
    }

  }


  simula(data: any) {

    this.liberarSelecaoParcelas = false;
    this.valorVenda = data.valorVenda;

    let register = {

      bandeira: this.bandeira,
      modalidade: data.modalidade,
      tipoTaxa: data.tipoTaxa,
      tipoTransacao: data.tipoTransacao,
      valorPago: data.valorPago,
      valorReceber: data.valorReceber,
      valorVenda: data.valorVenda,

    }

    this.spinnerService.show();
    this.service.simularVenda(
      register,
      (response) => {

        this.rowData = response;
        this.liberarSelecaoParcelas = true;
        this.spinnerService.hide();
        this.rowData = this.rowData.map((data) => {
          return {
            parcela: data.parcela,
            valor: data.valor,
            valorCobrar: data.valorCobrar,
            valorReceber: data.valorReceber,
            tipoTaxa: data.tipoTaxa,
            bandeira: data.bandeira,
            modalidadeTransacao: data.modalidadeTransacao,
            valorVenda: data.valorVenda,
          };
        });
      },
      (error) => {
        this.spinnerService.hide();
        this.notificationService.error(error.message);
      }
    );
  }

  gotoParcela(data) {
    this.parcelaSelecionada = data;
  }

  async pagamento() {
    if (!this.parcelaSelecionada || this.parcelaSelecionada === null) {
      this.notificationService.warn('Por favor, selecione uma parcela.');
      return;
    }

    this.spinnerService.show();

    let lastTransaction: any = null;
    let simuladorInfo: any = null;
    let vendaInfo: any = null;
    let confirmaVendaInfo: any = null;
    let financialInfo: any = this.createPinpadObject();
    let simulatorInfo: any = this.createSimulatorObject();
    this.transactionInfoBuilder = new TransactionInfoBuilder();
    this.transactionInfoBuilder
      .valor(this.financial.valueTransaction)
      .valorSemTaxas(this.valorVenda)
      .qtdParcelas(this.financial.plots)
      .bandeira(this.parcelaSelecionada.bandeira)
      .modalidade(this.parcelaSelecionada.modalidadeTransacao)
      .cpfCnpj(this.enterpriseFederalId)
      .tipoTaxa(this.parcelaSelecionada.tipoTaxa)
      .etapaProcessamento(EtapaProcessamento.TRANSACAO_PINPAD_PENDENTE)
      .modeloCaptura('GERTEC/SDK-ADIQ');
    let pdvReturn: any = null;

    try {
      pdvReturn = await this.financialService.requestFinancial(financialInfo)
        .toPromise();
    } catch (error) {
      await this.service
        .registrarLogTransacao(this.transactionInfoBuilder.getTransactionInfo())
        .toPromise();

      this.spinnerService.hide();
      this.notificationService.warn('Não foi possível realizar a transacao');
      this.limparForm();
      return;
    }

    if (pdvReturn.messagePdv !== 'TRANS. APROVADA') {
      if (pdvReturn.messagePdv === 'PRODUTO NÃO PERMITIDO') {
        this.notificationService.warn('Não foi possível realizar a transacao. Verifique a bandeira do cartão.');
        await this.service
          .registrarLogTransacao(this.transactionInfoBuilder.getTransactionInfo())
          .toPromise();
        this.spinnerService.hide();
        return;
      }


      await this.service
        .registrarLogTransacao(this.transactionInfoBuilder.getTransactionInfo())
        .toPromise();
      this.spinnerService.hide();
      this.notificationService.warn('Não foi possível realizar a transacao.');
      this.limparForm();
      return;
    }

    lastTransaction = await this.financialService
      .findAllTransactions()
      .toPromise();
    lastTransaction = lastTransaction[lastTransaction.length - 1];

    this.transactionInfoBuilder
      .numeroCartao(pdvReturn.pan)
      .codAuth(pdvReturn.codAuth)
      .codTerm(this.extractInfoFromMsgPdv(pdvReturn.receipt, '@TERM:', 8))
      .recibo(pdvReturn.receipt)
      .nsuTerminal(lastTransaction.nsuTerminal)
      .nsuHost(lastTransaction.nsuHost)
      .data(lastTransaction.transmissionDateHour.substring(0, 4))
      .hora(lastTransaction.transmissionDateHour.substring(4, 10))
      .codigoMensagem(lastTransaction.messageCode)
      .codigoProcessamento(lastTransaction.processCode)
      .etapaProcessamento(EtapaProcessamento.SIMULADOR_PENDENTE);

    try {

      simuladorInfo = await this.service
        .simularVendaPromise(simulatorInfo)
        .toPromise();
      simuladorInfo = simuladorInfo.filter((item) => item.selecaoUsuario === true);


      this.transactionInfoBuilder
        .pinSimuladorId(simuladorInfo[0].id)
        .codigoSimulador(simuladorInfo[0].codigoSimulador)
        .etapaProcessamento(EtapaProcessamento.VENDA_TX_PENDENTE);

      vendaInfo = await this.service
        .vendaPromise(this.transactionInfoBuilder.getTransactionInfo())
        .toPromise();


      this.transactionInfoBuilder
        .vendaTx(vendaInfo)
        .etapaProcessamento(EtapaProcessamento.CONFIRMA_VENDA_TX_PENDENTE);

      confirmaVendaInfo = await this.service
        .confirmaVendaPromise(this.transactionInfoBuilder.getTransactionInfo())
        .toPromise();

      this.transactionInfoBuilder
        .confirmaVendaTx(confirmaVendaInfo)
        .etapaProcessamento(EtapaProcessamento.FINALIZADO);

      await this.service
        .registrarLogTransacao(this.transactionInfoBuilder.getTransactionInfo())
        .toPromise();

    } catch (error) {
      await this.service
        .registrarLogTransacao(this.transactionInfoBuilder.getTransactionInfo())
        .toPromise();
    }


    this.showCardModal(this.transactionInfoBuilder.getTransactionInfo());
    this.limparForm();
    this.spinnerService.hide();
    this.notificationService.success('Transacao realizada com sucesso.');
  }

  createPinpadObject() {
    let type: any = null;
    let plots: string = '';
    if (this.parcelaSelecionada.modalidadeTransacao === 'DEBITO') {
      type = ModalidadeTransacao.DEBITO;
    } else if (this.parcelaSelecionada.modalidadeTransacao === 'CREDITO' && this.parcelaSelecionada.parcela === 1) {
      type = ModalidadeTransacao.CREDITO_VISTA;
    } else if (this.parcelaSelecionada.modalidadeTransacao === 'CREDITO' && this.parcelaSelecionada.parcela !== 1
    ) {
      type = ModalidadeTransacao.CREDITO_PARCELADO;
      plots = String(this.parcelaSelecionada.parcela);
    }

    if (!this.pinpadIsInit) {
      this.notificationService.error(
        'Realizar o setup antes de realizar qualquer operação.'
      );
      return;
    }
    this.financial.valueTransaction = Number.parseFloat(
      String(this.parcelaSelecionada.valorCobrar).replace(',', '.')
    ).toFixed(2);

    this.financial.typeTransaction = '1';
    this.financial.type = type;
    this.financial.plots = plots;
    this.financial.flag = this.parcelaSelecionada.bandeira;
    return this.financial;
  }

  createSimulatorObject() {
    return {
      valorVenda: this.valorVenda,
      tipoTaxa: this.parcelaSelecionada.tipoTaxa,
      bandeira: this.parcelaSelecionada.bandeira,
      modalidade: this.parcelaSelecionada.modalidadeTransacao,
      qtdParcelas: this.parcelaSelecionada.parcela,
      registraSimulacao: this.parcelaSelecionada.selected,
    };
  }

  extractInfoFromTransaction(value: any): any {
    this.transactionInfoBuilder = new TransactionInfoBuilder();
    this.transactionInfoBuilder
      .numeroCartao(value.pan)
      .codAuth(value.codAuth)
      .codTerm(this.extractInfoFromMsgPdv(value.receipt, '@TERM:', 8));
    return this.transactionInfoBuilder.getTransactionInfo;
  }

  extractInfoFromMsgPdv(msgPdvlue: string, value: string, length: number) {
    const initPosition: number = msgPdvlue.indexOf(value) + value.length;
    const endPosition: number = initPosition + length;
    return msgPdvlue.substring(initPosition, endPosition).trim();
  }

  findTransactionInfo(valueRet: any) {
    this.financialService.findAllTransactions().subscribe((response) => {
      const listRet: any = response;
      valueRet = listRet[listRet.length - 1];
    });
  }

  gerarSimulacao() {
    const promise = new Promise((resolve, reject) => {
      if (!this.parcelaSelecionada || this.parcelaSelecionada === null) {
        reject();
      } else {
        const register: any = {
          valorVenda: this.valorVenda,
          tipoTaxa: this.parcelaSelecionada.tipoTaxa,
          bandeira: this.parcelaSelecionada.bandeira,
          modalidade: this.parcelaSelecionada.modalidadeTransacao,
          qtdParcelas: this.parcelaSelecionada.parcela,
          registraSimulacao: this.parcelaSelecionada.selected,
        };
        let itemSelecionado: any = null;
        this.service.simularVenda(
          register,
          (response) => {
            itemSelecionado = response.filter(
              (item) => item.selecaoUsuario === true
            );
            resolve(itemSelecionado);
          },
          (error) => reject(error)
        );
      }
    });
    return promise;
  }

  efetuarTransacao() {
    if (!this.parcelaSelecionada || this.parcelaSelecionada === null) {
      this.notificationService.error('Nenhuma parcela selecionada');
      this.spinnerService.hide();
      return;
    } else {
      const register = {
        valorVenda: this.valorVenda,
        tipoTaxa: this.parcelaSelecionada.tipoTaxa,
        bandeira: this.parcelaSelecionada.bandeira,
        modalidade: this.parcelaSelecionada.modalidadeTransacao,
        qtdParcelas: this.parcelaSelecionada.parcela,
        registraSimulacao: this.parcelaSelecionada.selected,
      };

      this.service.simularVenda(
        register,
        (response) => {
          const itemSelecionado = response.filter(
            (item) => item.selecaoUsuario === true
          );

          this.rowData = response;

          if (itemSelecionado[0].selecaoUsuario === true) {
            const register: any = {
              valorVenda: itemSelecionado[0].valorCobrar,
              qtdParcelas: itemSelecionado[0].parcela,
              bandeira: itemSelecionado[0].bandeira,
              modalidadeTransacao: itemSelecionado[0].modalidadeTransacao,
            };

            this.notificationService.success('TRANSAÇÃO EFETUADA COM SUCESSO');
            this.limparForm();
          }
        },
        (error) => {
          this.limparForm();
          this.notificationService.error(error.message);
        }
      );
    }
  }

  limparForm() {
    this.formSimulaVenda = this.formBuilder.group({
      valorVenda: [null],
      tipoTaxa: [null],
      bandeira: [null],
      modalidade: [null],
      valorPago: [null],
      valorReceber: [null],
    });

    this.rowData = [];
    this.liberarSelecaoParcelas = false;
  }

  showCardModal(data: TransactionInfo) {
    this.dialogService.open(ModalSimulacaoVendaComponent, {
      context: {
        transactionInfo: data,
      },
    });
  }

  number(event): boolean {

    const charCode = (event.which) ? event.which : event.keyCode;

    if ((charCode == 45)) {

      this.formSimulaVenda.controls['valorVenda'].setValue(null);
      this.notificationService.error('Não é permitido números negativos!');

    }
    return true;

  }

  async buscaTerminais() {
    this.spinnerService.show();
    let listTerminaisStorage = localStorage.getItem('listaTerminais');

    if (listTerminaisStorage != null) {
      this.listTerminais = JSON.parse(listTerminaisStorage);
      this.setInitValues();
      this.spinnerService.hide();
    } else {
      let params = new HttpParams();
      params = params.append('cnpj', this.enterpriseFederalId);
      try {
        let terminalResponse: any = await this.service.buscaTerminaisPromise(params).toPromise()
        terminalResponse = terminalResponse.body;
        this.listTerminais = terminalResponse;
        localStorage.setItem('listaTerminais', JSON.stringify(terminalResponse));
        this.setInitValues();
        this.spinnerService.hide();
        if (this.listTerminais.length === 0) {
          this.notificationService.warn(
            'Não há terminais cadastrados para este estabelecimento'
          );
        }
      } catch (error) {
        this.spinnerService.hide();
        this.notificationService.error('Não foi possivel carregar os terminais');
      }
    }
  }

  previousPage() {
    this.router.navigate(['/iot-dashboard']);
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }
}
